/**
 * v-safe-html 指令 — 等保三级：净化 HTML 后再渲染，防止 XSS
 *
 * 用法：将 v-html 替换为 v-safe-html
 *   <div v-safe-html="aiOutput" />
 *
 * 内部调用 SecurityUtils.sanitizeHtml 做白名单过滤：
 * - 保留格式标签（p/strong/em/ul/table 等）
 * - 移除 script/iframe/on* 事件处理器/javascript: 协议等危险内容
 */
import type { Directive } from "vue";
import { SecurityUtils } from "@/utils/security";

export const safeHtmlDirective: Directive<HTMLElement> = {
  mounted(el, binding) {
    el.innerHTML = SecurityUtils.sanitizeHtml(binding.value);
  },
  updated(el, binding) {
    if (binding.value !== binding.oldValue) {
      el.innerHTML = SecurityUtils.sanitizeHtml(binding.value);
    }
  },
};

export function registerSafeHtml(app: import("vue").App) {
  app.directive("safe-html", safeHtmlDirective);
}

export default safeHtmlDirective;
